import React from "react";
import { Box } from "@mui/material";

const CommonErrorMessage = ({ error, sx }) => {
  if (!error) return null;
  return <Box sx={sx}>{error}</Box>;
};

export default CommonErrorMessage;
